import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '@contrast-security-inc/design-system-buttons'
import {
  PopoverMenu,
  Menu,
  MenuItem,
  MenuTrigger
} from '@contrast-security-inc/design-system-popovers'
import {
  IconDropdownCollapse,
  IconDropdownExpand
} from '@contrast-security-inc/design-system-foundations'

interface Props {
  readonly onApprove: () => void
  readonly onDeny: () => void
  readonly menuPlacement: 'top' | 'bottom'
}

export function ReviewMenu({ onApprove, onDeny, menuPlacement }: Props) {
  const { formatMessage } = useIntl()

  return (
    <PopoverMenu placement={menuPlacement}>
      <Menu>
        <MenuItem itemID="approve" onClick={onApprove}>
          {formatMessage({ id: 'action_approve' })}
        </MenuItem>
        <MenuItem itemID="deny" onClick={onDeny}>
          {formatMessage({ id: 'action_deny' })}
        </MenuItem>
      </Menu>
      <MenuTrigger>
        {({ isOpen }) => (
          <Button
            variant="secondary"
            Icon={isOpen ? IconDropdownCollapse : IconDropdownExpand}
          >
            {formatMessage({ id: 'action_review' })}
          </Button>
        )}
      </MenuTrigger>
    </PopoverMenu>
  )
}
